<template>
    <Application
        :mynav="menuNav"
        @DangXuat="DangXuat"
        PhienBan="0.0.211005.1"
        :propModelToast="modelToast"
        :SoThongBaoChuaDoc="SoThongBaoChuaDoc"
        :SoThongBaoLoiChuaDoc="SoThongBaoLoiChuaDoc"
        @ClickCaiDat="ClickCaiDat"
        @ClickThongBao="ClickThongBao"
        :KeyStorageState="KeyStorageState"
        v-if="!isMobile"
    >
        <template v-slot:default>
            <slot />
        </template>
    </Application>

    <AppMobileNotFooterVue v-if="isMobile">
        <template v-slot:default>
            <slot />
        </template>
    </AppMobileNotFooterVue>

    <!-- <div class="so-thong-bao-loi-chua-doc" v-if="SoThongBaoLoiChuaDoc > 0">
        Bạn có {{ SoThongBaoLoiChuaDoc }} thông báo lỗi chưa đọc!
    </div> -->
</template>

<script>
import { DxButton } from "devextreme-vue";
import Application from "@sonphat/common-v1/components/application.vue";
import AppMobileVue from "./AppMobile.vue";
import AppMobileNotFooterVue from "./AppMobileNotFooter.vue";

const base_ThanhToan = SP["FE_ThanhToan"];
const base_ThongTin = SP["FE_ThongTin"];
const base_DieuDo = SP["FE_DieuDo"];
const base_KeHoach = SP["FE_KeHoach"];
const base_BaoCao = SP["FE_BaoCao"];
const base_CauHinh = SP["FE_CauHinh"];
export default {
    components: { Application, DxButton, AppMobileVue, AppMobileNotFooterVue },
    data() {
        return {
            menuNav: [],
            KeyApp: "QuanLyThongTin",
            openState: false,
            modelToast: {
                isVisible: false,
                message: "",
                type: "success",
            },
            HienThiSoThongBaoLoiChuaDoc: false,
            KeyStorageState: "QLBX_StateMenu",
        };
    },
    computed: {
        isMobile: {
            get() {
                return this.$store.state.ManHinh.isMobile;
            },
            set(data) {
                this.$store.commit("ManHinh/Set", {
                    key: "isMobile",
                    data: data,
                });
            },
        },
    },
    methods: {
        DangXuat() {
            this.$Core.Auth.Logout();
        },
        async getMenu() {
            this.menuNav = [
                {
                    id: "Home",
                    text: "Trang chủ",
                    icon: "home",
                    to: "/",
                    external: false,
                },
                {
                    id: "KhaiBaoVe",
                    icon: "mdi mdi-ticket",
                    text: "Khai báo vé",
                    to: "/Khai-Bao-Ve",
                    external: false,
                },
                {
                    id: "QuanLyThongTin",
                    text: "Quản lý thông tin",
                    icon: "mdi mdi-inbox-arrow-down",
                    role: "",
                    expanded: false,
                },
                {
                    parent: "QuanLyThongTin",
                    id: "QuanLyThongTinDoanhNghiep",
                    icon: "mdi mdi-home-city-outline",
                    text: "Doanh nghiệp",
                    to: "/Quan-Ly-Thong-Tin/Doanh-Nghiep",
                    external: false,
                },
                {
                    parent: "QuanLyThongTin",
                    id: "QuanLyThongTinNhanVien",
                    icon: "mdi mdi-account-multiple-outline",
                    text: "Nhân viên",
                    to: "/Quan-Ly-Thong-Tin/Nhan-Vien",
                    external: false,
                },
                {
                    parent: "QuanLyThongTin",
                    id: "QuanLyThongTinNhomThe",
                    icon: "mdi mdi-account-multiple-outline",
                    text: "Nhóm thẻ",
                    to: "/Quan-Ly-Thong-Tin/Nhom-The",
                    external: false,
                },
                {
                    parent: "QuanLyThongTin",
                    id: "QuanLyThongTinTheKiemSoat",
                    icon: "mdi mdi-card-bulleted-outline",
                    text: "Thẻ kiểm soát",
                    to: "/Quan-Ly-Thong-Tin/The-Kiem-Soat",
                    external: false,
                },
                {
                    id: "BaoCao",
                    text: "Báo cáo",
                    icon: "mdi mdi-chart-box-outline",
                    role: "",
                    expanded: false,
                },
                {
                    parent: "BaoCao",
                    id: "Lich-Su-Cap-The",
                    icon: "mdi mdi-chart-timeline",
                    text: "Lịch sử cấp thẻ",
                    to: "/Bao-Cao/Lich-Su-Cap-The",
                    external: false,
                },
                {
                    parent: "BaoCao",
                    id: "Ve-Doanh-Nghiep-Tu-Khai-Bao",
                    icon: "mdi mdi-chart-timeline",
                    text: "Vé doanh nghiệp tự khai báo",
                    to: "/Bao-Cao/Ve-Doanh-Nghiep-Tu-Khai-Bao",
                    external: false,
                },
                {
                    parent: "BaoCao",
                    id: "Ve-Kiem-Soat-Tai-Cong",
                    icon: "mdi mdi-chart-timeline",
                    text: "Vé kiểm soát tại cổng",
                    to: "/Bao-Cao/Ve-Kiem-Soat-Tai-Cong",
                    external: false,
                },
            ];
        },
        getPath(type) {
            if (type == "DieuDo") {
                return base_DieuDo;
            }
            if (type == "ThanhToan") {
                return base_ThanhToan;
            }
            if (type == "KeHoach") {
                return base_KeHoach;
            }
            if (type == "QuanLyThongTin") {
                return base_ThongTin;
            }
            if (type == "BaoCao") {
                return base_BaoCao;
            }
            if (type == "CauHinh") {
                return base_CauHinh;
            }
            return null;
        },
        checkPath(url) {
            let u = new URL(url);
            let arr = u.pathname.split("//");
            u.pathname = arr.join("/");
            return "" + u;
        },
    },
    mounted() {
        let self = this;
        this.emitter.on("onToast", (params) => {
            self.modelToast = params;
        });
    },
    created() {
        this.getMenu();
    },
};
</script>

<style scoped>
:deep(.icon-toast .dx-icon) {
    font-size: 36px;
}
:deep(.icon-toast) {
    position: relative;
    left: -16px;
}
.so-thong-bao-loi-chua-doc {
    position: fixed;
    bottom: 48px;
    background: red;
    left: 8px;
    color: #fff;
    font-size: 16px;
    padding: 4px 8px;
    box-shadow: 0 3px 5px #dadce0;
    border-radius: 4px;
    z-index: 1500;
}
</style>
